import React from "react";
import {
    HeaderMainWrapper,
    HeaderText,
    HeaderButtonsWrapper,
    HeaderButton,
} from "./StyledComponents";
import { useTranslation } from "react-i18next";
import useCalendar from "../../calendar/context/useCalendar";
import { useSelector } from "../../store/store";
import { isRegularChanged, isIndividualChanged } from "../../store/data";
interface Props {
    isRegular: boolean;
    setIsRegular: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header = ({ isRegular, setIsRegular }: Props) => {
    const handleClick = (isRegular: boolean) => setIsRegular(isRegular);
    const { t } = useTranslation();

    let regularChanged = useSelector(isRegularChanged);
    let individualChanged = useSelector(isIndividualChanged);

    const {
        profile: { doctorName },
        inputCallbacks,
    } = useCalendar();

    return (
        <HeaderMainWrapper>
            <HeaderText>
                {/* {t("add_consultation")} */}
                {doctorName} - {t("add_consultation")}
            </HeaderText>
            <HeaderButtonsWrapper>
                <HeaderButton
                    onClick={() => {
                        if (
                            individualChanged &&
                            inputCallbacks.changeWithoutSave
                        ) {
                            inputCallbacks.changeWithoutSave();
                            return;
                        }
                        handleClick(true);
                        // handleClick.bind(null, true);
                    }}
                    active={isRegular}
                >
                    {t("weekly_view")}
                </HeaderButton>
                <HeaderButton
                    onClick={() => {
                        if (
                            regularChanged &&
                            inputCallbacks.changeWithoutSave
                        ) {
                            inputCallbacks.changeWithoutSave();
                            return;
                        }
                        handleClick(false);
                        // handleClick.bind(null, false);
                    }}
                    active={!isRegular}
                >
                    {t("daily_view")}
                </HeaderButton>
            </HeaderButtonsWrapper>
        </HeaderMainWrapper>
    );
};

export default Header;
